import React, { useLayoutEffect, useState } from 'react';
import queryString from 'query-string';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from 'utils';
import { AppBarPayment, Card, Option, SideBar } from '../alf-design';
import { Background } from 'components/layout';
import PaymentFooter from './PaymentFooter';
import { Initial, Summary } from './pages';

const PaymentLayout = () => {
  const navigate = useNavigate();
  const [policyNumber, setPolicyNumber] = useState(null);
  const [step, setStep] = useState('form');
  const [paymentData, setPaymentData] = useState(null);
  const [openSideBar, setOpenSideBar] = useState(false);
  const { loginWithRedirect } = useAuth0();

  useLayoutEffect(() => {
    document.title = 'One-Time payment for Slide Insurance Policyholders';
    const { ...params } = queryString.parse(location.search);
    if (params?.policyNumber) {
      setPolicyNumber(params?.policyNumber);
    }
  }, [location]);

  const handleLogin = async () => {
    setOpenSideBar(false);
    await loginWithRedirect();
  };

  const handleCreateAccount = () => {
    setOpenSideBar(false);
    window.open(`/create-account`, '_blank');
  };

  const handleLogo = () => {
    setOpenSideBar(false);
    navigate('/payments', { replace: true });
  };

  const handleSideBar = (e) => {
    e.preventDefault();
    setOpenSideBar(!openSideBar);
  };

  return (
    <div className="relative h-full">
      <SideBar
        open={openSideBar}
        title="Make one-time payment"
        onClose={() => setOpenSideBar(false)}
      >
        <>
          <Option
            alt="Create Account page"
            title="Create Account"
            iconName="questionCircle"
            onClick={handleCreateAccount}
          />
          <Option title="Log In" iconName="userCircle" onClick={handleLogin} />
        </>
      </SideBar>

      <Background>
        <AppBarPayment
          onLogin={handleLogin}
          onCreateAccount={handleCreateAccount}
          onSideBar={handleSideBar}
          onLogo={handleLogo}
          breakpoint="md"
        />
        <main id="main-content" role="main">
          <div aria-hidden={openSideBar}>
            <div className="bg-legacy-dashboardBg flex flex-col flex-1 p-[24px] md:pt-[30px] md:pb-[100px] md:px-[160px]">
              <Card className="shadow-[0px_4px_13px_-10px_black] !p-[40px]">
                {step === 'form' ? (
                  <Initial
                    policyNumber={policyNumber ?? ''}
                    setStep={setStep}
                    setPaymentData={setPaymentData}
                  />
                ) : (
                  <Summary data={paymentData} />
                )}
              </Card>
            </div>
          </div>
        </main>
        <PaymentFooter />
      </Background>
    </div>
  );
};

export default PaymentLayout;
